module.exports = __webpack_public_path__ + "assets/img/img_money.b0d16a3e.svg";